<template>
	<GetApp :mobile-type="mobileType" :icon-path="googlePlayIcon" :download-path="googlePlayDownloadPath" />
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import GetApp from '@views/mobile/get-app.vue';
import { SupportedMobile } from 'types/mobile';

const mobileType: SupportedMobile = 'Android';

const googlePlayIcon = `${appCloudfrontPath}/images/google-play-badge-cropped.png`;
const googlePlayDownloadPath = `${import.meta.env.VITE_AVATAR_URL}/play-store-redirect`;
</script>
